import React, { Component } from 'react';

import './about.css';

export class About extends Component {
  render () {
    return (
      <div className="about-text">
        <h1>Alexa Kearns</h1>
        <p>Full stack developer and recent graduate from highly selective Makers Academy software engineering course.</p>
      </div>
    );
  }
}

export default About;
